var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilesblue = function SvgFilesblue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0045A1",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.336 15.333h5.333M9.336 12.667h2.667M12.664 5.666V6c0 1.885 0 2.828.586 3.414s1.528.586 3.414.586h.333m.334 1.104v2.229c0 2.514 0 3.771-.781 4.552s-2.039.781-4.553.781-3.77 0-4.552-.78c-.78-.782-.78-2.039-.78-4.553v-3.03c0-2.163 0-3.244.59-3.977q.18-.223.402-.402c.733-.591 1.814-.591 3.978-.591.47 0 .705 0 .92.076q.068.024.132.055c.206.098.372.264.705.597l3.158 3.158c.385.385.578.578.68.823.1.245.1.517.1 1.062"
  })));
};
export default SvgFilesblue;